export default "__VITE_ASSET__4oX3R1fr__"